module.exports = __webpack_public_path__ + "img/Origine.8cfbc0d2.png";